// src/components/sidebar/ProSidebarLayout.tsx
import React from 'react';
import '../../../src/styles/ProSidebarBase.css';
import { Outlet } from 'react-router-dom';

import UserSidebar from './UserSidebar';

const UserSidebarLayout = () => {
  return (
    <div className="app-layout">
      <UserSidebar />
      <main className="app-main">
        <div className="app-main-inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default UserSidebarLayout;
